import { render, staticRenderFns } from "./NavMenu.vue?vue&type=template&id=88c1a4fa&scoped=true"
import script from "./NavMenu.ts?vue&type=script&lang=ts&external"
export * from "./NavMenu.ts?vue&type=script&lang=ts&external"
import style0 from "./NavMenu.vue?vue&type=style&index=0&id=88c1a4fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c1a4fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88c1a4fa')) {
      api.createRecord('88c1a4fa', component.options)
    } else {
      api.reload('88c1a4fa', component.options)
    }
    module.hot.accept("./NavMenu.vue?vue&type=template&id=88c1a4fa&scoped=true", function () {
      api.rerender('88c1a4fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Core/components/NavMenu/NavMenu.vue"
export default component.exports